import React, { useState, useEffect } from 'react';
import { css } from '@emotion/react';
import EyeSVG from '@birdi/icons/eye.svg';
import EyeOffSVG from '@birdi/icons/eye-off.svg';

interface PasswordProps {
  name?: string;
  label?: string;
  value: string;
  onChange: (value: string) => void;
  required?: boolean;
  minLength?: number;
}

const Password = ({
  name = 'password',
  label = 'Password',
  value,
  onChange,
  required = true,
  minLength = 8,
}: PasswordProps) => {
  const [show, setShow] = useState(false);

  const togglePasswordDisplay = (
    event: React.MouseEvent<HTMLButtonElement>,
  ) => {
    event.preventDefault();
    setShow((prevShow) => !prevShow);
  };

  return (
    <div>
      <label htmlFor={name}>
        {label}
        <div
          css={css`
            position: relative;
          `}
        >
          <input
            type={show ? 'text' : 'password'}
            data-cy="password"
            id={name}
            value={value}
            onInput={(event) =>
              onChange((event.target as HTMLInputElement).value)
            }
            required={required}
            minLength={minLength}
          />
          <button
            onClick={togglePasswordDisplay}
            type="button"
            css={css`
              position: absolute;
              top: 1.2rem;
              right: 0.5rem;
              z-index: 10;
              cursor: pointer;
            `}
          >
            {show ? <EyeOffSVG /> : <EyeSVG />}
          </button>
        </div>
      </label>
    </div>
  );
};

export default Password;
